import { useBadge, useCourse } from 'querys/course'
import styled from 'styled-components'


const BadgeCompositionStyled = styled.div`
  --angle: rotateY(35deg);
  position: relative;
  block-size: 120px;
  inline-size: 120px;
  margin: 0 auto;
  img {
    max-width: 100%;
    height: auto;
  }
  .layer {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    transition: 1s ease-in-out;
    filter: drop-shadow(0px 0px 40px ${({ color }) => `${color}33`});
  }
  &:hover {
    .layer {
      filter: drop-shadow(0px 0px 30px ${({ color }) => color});
      &:nth-of-type(1) {
        transform: var(--angle) translate3D(-110%, 0, 0);
      }
      &:nth-of-type(2) {
        transform: var(--angle) translate3D(-72%, 0, 1px);
      }
      &:nth-of-type(3) {
        transform: var(--angle) translate3D(-27%, 0, 2px);
      }
      &:nth-of-type(4) {
        transform: var(--angle) translate3D(7%, 0, 3px);
      }
      &:nth-of-type(5) {
        transform: var(--angle) translate3D(62%, 0, 4px);
      }
      &:nth-of-type(6) {
        transform: var(--angle) translate3D(110%, 0, 5px);
      }
    }
  }
  .state {
    opacity: 0;
  }
  @media(min-width: 768px) {
    block-size: 160px;
    inline-size: 160px;
  }
`

function BadgeComposition() {
  const { data, isLoading, isError } = useBadge()

  if (isLoading || isError) return null

  const { badge, badge_layers, badge_state } = data

  if (!badge_layers && badge_state) {
    return (
      <img src={badge_state.image} width="160" height="160" alt={`Estado actual de la medatalla que posees por completar clases, estas en la etapa ${badge_state.name}`} />
    )
  }

  return (
    <BadgeCompositionStyled color={badge.color}>
      {badge_layers.map(({ name, image }) => (
        <img
          key={name}
          src={image}
          width="160"
          height="160"
          alt={`Estado actual de la medatalla que posees por completar clases, estas en la etapa ${name}`}
          loading="lazy"
          className="layer"
        />
      ))}
    </BadgeCompositionStyled>
  )
}

export default BadgeComposition
